module.exports = __webpack_public_path__ + "static/media/XXVIe.725aa464.png";